import React from 'react';
import * as LucideIcons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

type PillKind = 'default' | 'accent' | 'green' | 'amber' | 'slate' | 'ghost' | 'solid';

interface PillProps {
  kind?: PillKind;
  icon?: keyof typeof LucideIcons;
  iconRight?: keyof typeof LucideIcons;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export function Pill({ kind = 'default', icon, iconRight, children, className = '', style, onClick }: PillProps) {
  const Icon = icon ? ((LucideIcons[icon] || null) as LucideIcon | null) : null;
  const IconRight = iconRight ? ((LucideIcons[iconRight] || null) as LucideIcon | null) : null;
  const iconSize = 12;
  const Tag = onClick ? 'button' : 'span';

  return (
    <Tag
      className={`pill ${kind !== 'default' ? kind : ''} ${className}`}
      style={style}
      onClick={onClick}
      type={onClick ? 'button' : undefined}
    >
      {Icon && <Icon size={iconSize} strokeWidth={2.4} />}
      <span>{children}</span>
      {IconRight && <IconRight size={iconSize} strokeWidth={2.4} />}
    </Tag>
  );
}
